import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGooglePay = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 46,
	height: 24,
	fill: "none",
	viewBox: "0 0 46 24",
	id: "google-pay_icon",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M33.912 0H12.636C5.988 0 .548 5.4.548 12s5.44 12 12.088 12h21.276C40.56 24 46 18.6 46 12S40.56 0 33.912 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#3C4043",
			d: "M33.912.972c1.493 0 2.943.294 4.31.87a11.2 11.2 0 0 1 3.535 2.37 11.1 11.1 0 0 1 2.387 3.51c.58 1.356.877 2.796.877 4.278s-.296 2.922-.877 4.278a11.1 11.1 0 0 1-2.387 3.51 11.1 11.1 0 0 1-3.536 2.37c-1.366.576-2.816.87-4.31.87H12.637c-1.493 0-2.943-.294-4.31-.87a11.2 11.2 0 0 1-3.535-2.37 11.1 11.1 0 0 1-2.387-3.51A10.8 10.8 0 0 1 1.527 12c0-1.482.296-2.922.877-4.278a11.1 11.1 0 0 1 2.387-3.51 11.14 11.14 0 0 1 7.845-3.24zm0-.972H12.636C5.988 0 .548 5.4.548 12s5.44 12 12.088 12h21.276C40.56 24 46 18.6 46 12S40.56 0 33.912 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#3C4043",
			d: "M22.222 12.852v3.63h-1.16V7.518h3.076q1.171 0 1.989.774.834.774.834 1.89a2.47 2.47 0 0 1-.834 1.902q-.809.763-1.989.762h-1.916zm0-4.23v3.126h1.94c.46 0 .847-.156 1.149-.462.308-.306.465-.678.465-1.098 0-.414-.157-.78-.465-1.086q-.452-.476-1.148-.474h-1.94v-.006Zm7.773 1.524q1.287 0 2.031.684t.743 1.872v3.78h-1.106v-.852h-.048q-.717 1.052-1.916 1.05-1.023.002-1.71-.6-.69-.601-.69-1.5 0-.954.726-1.512.726-.566 1.934-.564 1.035 0 1.698.378v-.264c0-.402-.157-.738-.477-1.02a1.65 1.65 0 0 0-1.124-.42q-.971-.002-1.536.816l-1.021-.636q.844-1.213 2.496-1.212m-1.499 4.452q-.002.452.387.75.383.299.9.3.735 0 1.306-.54.572-.538.574-1.266-.542-.425-1.51-.426-.708.002-1.18.336-.479.351-.477.846m10.584-4.254-3.869 8.832h-1.197l1.439-3.09-2.55-5.742h1.263l1.837 4.404h.024l1.79-4.404z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4285F4",
			d: "M17.606 12.12q-.002-.563-.096-1.08h-4.865v1.98h2.802a2.38 2.38 0 0 1-1.04 1.595v1.284h1.668c.974-.894 1.531-2.217 1.531-3.779"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#34A853",
			d: "M14.408 14.615c-.464.31-1.062.492-1.761.492-1.351 0-2.497-.903-2.908-2.121H8.02v1.325a5.18 5.18 0 0 0 4.627 2.83c1.4 0 2.574-.456 3.43-1.242z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FABB05",
			d: "M9.577 12.003c0-.342.058-.673.162-.983V9.695H8.02a5.1 5.1 0 0 0-.55 2.308c0 .83.198 1.614.55 2.308l1.72-1.325a3.1 3.1 0 0 1-.162-.983Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#E94235",
			d: "M12.646 8.898c.764 0 1.447.261 1.987.771l1.478-1.466c-.898-.83-2.068-1.339-3.465-1.339a5.18 5.18 0 0 0-4.627 2.83l1.72 1.326c.41-1.218 1.557-2.122 2.907-2.122"
		})
	]
});
export { SvgGooglePay as ReactComponent };
